import React, { useState, useEffect } from "react";
import { Menu, Tooltip } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import { menuItems } from "../utils/sideBarUtils";
import { rightsService } from "../services/rightsService";
import { inlineStyles } from "./ui/sidebarStyles";

const LAYOUT_BREAKPOINT = 1200;

const SideBar = ({ currentMenu = "DASHBOARD", backgroundColor = "#212466" }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [openKeys, setOpenKeys] = useState(["PARAMETRES"]);

    // Appliquer la classe au body au montage du composant
    useEffect(() => {
        const htmlElement = document.documentElement;
        if (collapsed) {
            htmlElement.classList.add("layout-menu-collapsed");
            htmlElement.classList.remove("layout-menu-expanded");
        } else {
            htmlElement.classList.add("layout-menu-expanded");
            htmlElement.classList.remove("layout-menu-collapsed");
        }
    }, [collapsed]);

    const isSmallScreen = () => {
        return window.innerWidth < LAYOUT_BREAKPOINT;
    };

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
        if (!isSmallScreen()) {
            const htmlElement = document.documentElement;
            if (!collapsed) {
                htmlElement.classList.remove("layout-menu-expanded");
                htmlElement.classList.add("layout-menu-collapsed");
            } else {
                htmlElement.classList.remove("layout-menu-collapsed");
                htmlElement.classList.add("layout-menu-expanded");
            }
        }
    };

    const onOpenChange = (keys) => {
        setOpenKeys(keys);
    };

    const convertToMenuItems = (items) => {
        return items.map((item) => {
            if (item.right && !rightsService(item.right)) {
                return;
            }
            if (item.type === "divider") {
                if (item.right && !rightsService(item.right)) {
                    return;
                } else {
                    return item.right && !rightsService(item.right) ? null : {
                        type: "group",
                        label: !collapsed && (
                            <div style={inlineStyles.sectionHeader(collapsed)}>
                                {item.section}
                            </div>
                        ),
                    };
                }
            }

            if (item.children) {
                return {
                    key: item.key,
                    icon: collapsed ? (
                        <Tooltip title={item.label} placement="right">
                            {item.icon}
                        </Tooltip>
                    ) : (
                        item.icon
                    ),
                    label: item.label,
                    children: item.children.map((child) => {
                        if (child.right && !rightsService(child.right)) {
                            console.log(child.right)
                        } else {
                            return {
                                key: child.key,
                                label: <a href={child.link} style={{ color: "inherit" }}>{child.label}</a>,
                            };
                        }
                    }),
                    style: inlineStyles.submenuTitleStyle,
                };
            }

            return {
                key: item.key,
                icon: collapsed ? (
                    <Tooltip title={item.label} placement="right">
                        {item.icon}
                    </Tooltip>
                ) : (
                    item.icon
                ),
                label: <a href={item.link} style={{ color: "inherit" }}>{item.label}</a>,
                style: inlineStyles.menuItemStyle,
            };
        });
    };

    return (
        <aside style={inlineStyles.sidebar(collapsed, backgroundColor)}>
            {/* Header avec logo et toggle */}
            <div style={inlineStyles.header(collapsed)}>
                {!collapsed && (
                    <div style={{ background: "white", padding: "0px", borderRadius: "8px", maxWidth: "120px", margin: "0 auto", alignItems: "center" }}>
                        <Logo />
                    </div>
                )}
                <div
                    style={inlineStyles.toggleButton}
                    onClick={toggleCollapsed}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                        e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                        e.currentTarget.style.transform = "scale(1)";
                    }}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </div>
            </div>

            {/* Menu */}
            <div style={inlineStyles.menuContainer}>
                <Menu
                    mode="inline"
                    selectedKeys={[currentMenu]}
                    openKeys={openKeys}
                    onOpenChange={onOpenChange}
                    inlineCollapsed={collapsed}
                    items={convertToMenuItems(menuItems)}
                    style={inlineStyles.menuStyle}
                    theme="dark"
                    inlineIndent={20}
                />
            </div>

            <style>
                {`
                    /* Scrollbar personnalisée */
                    aside::-webkit-scrollbar {
                        width: 6px;
                    }
                    aside::-webkit-scrollbar-track {
                        background: transparent;
                    }
                    aside::-webkit-scrollbar-thumb {
                        background: rgba(255, 255, 255, 0.2);
                        border-radius: 3px;
                    }
                    aside::-webkit-scrollbar-thumb:hover {
                        background: rgba(255, 255, 255, 0.3);
                    }

                    /* Ajustement du layout-page en fonction de l'état de la sidebar */
                    .layout-menu-expanded .layout-page {
                        padding-left: 260px !important;
                        transition: padding-left 0.3s ease;
                    }
                    
                    .layout-menu-collapsed .layout-page {
                        padding-left: 80px !important;
                        transition: padding-left 0.3s ease;
                    }

                    /* Styles du menu Ant Design */
                    .ant-menu-dark {
                        background: transparent !important;
                    }
                    .ant-menu-dark .ant-menu-item {
                        color: rgba(255, 255, 255, 0.85) !important;
                        background: rgba(255, 255, 255, 0.04) !important;
                        margin: 6px 0 !important;
                        border-radius: 10px !important;
                        transition: all 0.3s ease !important;
                    }
                    .ant-menu-dark .ant-menu-item:hover {
                        background: rgba(74, 144, 226, 0.15) !important;
                        color: #ffffff !important;
                        transform: translateX(4px);
                    }
                    .ant-menu-dark .ant-menu-item-selected {
                        background:  rgba(255, 255, 255, 0.04) !important;
                        color: #ffffff !important;
                        box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3) !important;
                    }
                    .ant-menu-dark .ant-menu-submenu-title {
                        color: rgba(255, 255, 255, 0.85) !important;
                        background: rgba(255, 255, 255, 0.14) !important;
                        border-radius: 10px !important;
                        margin: 6px 0 !important;
                        transition: all 0.3s ease !important;
                    }
                    .ant-menu-dark .ant-menu-submenu-title:hover {
                        background: rgba(74, 144, 226, 0.15) !important;
                        color: #ffffff !important;
                    }
                    .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
                        background: rgba(74, 144, 226, 2.9) !important;
                        color: #ffffff !important;
                    }
                    .ant-menu-dark .ant-menu-sub {
                        background: rgba(0, 0, 0, 0.15) !important;
                        border-radius: 8px !important;
                        padding: 4px 0 !important;
                        margin-top: 4px !important;
                    }
                    .ant-menu-dark .ant-menu-item-group-title {
                        padding: 0 !important;
                        color: transparent !important;
                    }
                    .ant-menu-inline-collapsed > .ant-menu-item,
                    .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
                        padding: 0 calc(50% - 18px / 2) !important;
                    }
                    .ant-menu-inline-collapsed .ant-menu-item {
                        background: rgba(255, 255, 255, 0.05) !important;
                    }
                    .ant-menu-inline-collapsed .ant-menu-item:hover {
                        background: rgba(74, 144, 226, 0.2) !important;
                    }
                    .ant-menu-inline-collapsed .ant-menu-item-selected {
                        background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%) !important;
                    }
                `}
            </style>
        </aside>
    );
};

export default SideBar;
